import { render, staticRenderFns } from "./ProductsCatalog.vue?vue&type=template&id=34900786&scoped=true&"
import script from "./ProductsCatalog.vue?vue&type=script&lang=js&"
export * from "./ProductsCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCatalog.vue?vue&type=style&index=0&id=34900786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34900786",
  null
  
)

export default component.exports